export enum PaymentPlanCodes {
  MONTHLY = 'tables-ready-standard-nt',
  ANNUAL = 'tablesready-standard-annual',
  Free = 'tablesready-free',
  Premium1000Monthly = 'tablesready-premium-1000-monthly',
  Premium1000Annual = 'tablesready-premium-1000-annual',
  Premium2500Monthly = 'tablesready-premium-2500-monthly',
  Premium2500Annual = 'tablesready-premium-2500-annual',
  Premium5000Monthly = 'tablesready-premium-5000-monthly',
  Premium5000Annual = 'tablesready-premium-5000-annual',
  Premium10000Monthly = 'tablesready-premium-10000-monthly',
  Premium10000Annual = 'tablesready-premium-10000-annual',
  Premium20000Monthly = 'tablesready-premium-20000-monthly',
  Premium20000Annual = 'tablesready-premium-20000-annual',
  Premium30000Monthly = 'tablesready-premium-30000-monthly',
  Premium30000Annual = 'tablesready-premium-30000-annual',
  Premium40000Monthly = 'tablesready-premium-40000-monthly',
  Premium40000Annual = 'tablesready-premium-40000-annual',
  Enterprise = 'tablesready-premium-enterprise',
}
